/**
 * Use Case: Fetch Voucher Detail
 * Business logic for fetching voucher detail by ID.
 */

import type { VoucherDetail } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch voucher detail by ID
 */
export const FetchVoucherDetailUseCase = async (
  voucherId: string
): Promise<VoucherDetail> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchVoucherDetail(voucherId);
};

